module.exports = __webpack_public_path__ + "img/UTSAND-5.d9401140.jpg";